import { render, staticRenderFns } from "./upload-pic-thumb.vue?vue&type=template&id=d972caac"
import script from "./upload-pic-thumb.vue?vue&type=script&lang=js"
export * from "./upload-pic-thumb.vue?vue&type=script&lang=js"
import style0 from "./upload-pic-thumb.vue?vue&type=style&index=0&id=d972caac&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports